export default __webpack_public_path__ + "static/media/BecaMilano_Curso01_Banner_Home.41e4dea1.jpg";